<template>
  <div>
    <splitpanes>
      <pane size="73" min-size="40">
        <!-- 中间区域 -->
        <div class="main">
          <div class="breadcrumb">
            <el-breadcrumb separator="/">
              <el-breadcrumb-item :to="{ path: '/home' }"
                >首页</el-breadcrumb-item
              >
              <el-breadcrumb-item>项目详情</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <el-scrollbar
            ref="hotScroll"
            style="height: calc(100vh - 110px)"
            v-loading="loading"
          >
            <div class="main-box">
              <!-- 项目信息 -->
              <project-info-tabs
                v-if="baseDetailData.customerName"
                :baseDetailData="baseDetailData"
                :projectTabsValue="projectTabsValue"
                :projectTabs="projectTabs"
                @tabsProjectNo="getTableAndDetail"
              ></project-info-tabs>
              <!-- 需求列表 -->
              <div class="table-list">
                <div class="demand-head">
                  <h4><i class="iconfont icon-base-list"></i>需求列表</h4>
                  <el-button
                    icon="el-icon-plus"
                    @click="openDialogAddDemand"
                    :disabled="baseDetailData.projectSituation !== 0"
                    >新建需求</el-button
                  >
                </div>

                <div style="flex: 1; position: relative">
                  <div
                    style="margin-top: 15px; position: absolute; width: 100%"
                  >
                    <el-table
                      v-loading="tableLoading"
                      :row-class-name="tableRowClassName"
                      :data="tableData"
                      style="width: 100%"
                      size="medium"
                      :highlight-current-row="true"
                      ref="planTable"
                      @row-click="clickRow"
                      @sort-change="sortChange"
                      :max-height="tableHeight"
                    >
                      <el-table-column prop="demandNo" label="ID" width="160">
                        <template slot-scope="scope">
                          FW{{ scope.row.demandNo }}
                        </template>
                      </el-table-column>
                      <el-table-column label="需求描述">
                        <template slot-scope="scope">
                          <div
                            class="demand-desc"
                            v-html="scope.row.demandDescription"
                          ></div
                        ></template>
                      </el-table-column>
                      <el-table-column
                        prop="createUserName"
                        label="需求发起人"
                        align="center"
                        width="100"
                      >
                      </el-table-column>
                      <el-table-column
                        prop="created"
                        label="提交时间"
                        width="180"
                        align="center"
                        sortable="custom"
                      >
                      </el-table-column>
                      <el-table-column
                        prop="demandStatus"
                        label="状态"
                        align="center"
                        width="160"
                      >
                        <template slot-scope="scope">
                          <el-tag
                            size="medium"
                            style="width: 58px"
                            :type="
                              scope.row.demandStatus === 1
                                ? 'danger'
                                : scope.row.demandStatus === 0
                                ? 'warning'
                                : scope.row.demandStatus === 4
                                ? 'info'
                                : scope.row.demandStatus === 2
                                ? ''
                                : scope.row.demandStatus === 3
                                ? 'success'
                                : 'feedback'
                            "
                            >{{ handleState(scope.row.demandStatus) }}</el-tag
                          >
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </div>
              </div>
            </div>
          </el-scrollbar>
        </div>
      </pane>

      <pane size="27" min-size="20" max-size="60">
        <!-- 右侧内容 需求详情面板 -->
        <div style="background: #fff; width: 100%; height: calc(100vh - 60px)">
          <!-- v-if="SidePanelData" -->
          <side-panel
            v-if="SidePanelData"
            v-loading="tableLoading"
            :SidePanelData="SidePanelData"
            :showChoice="showChoice"
            :disabled="baseDetailData.projectSituation !== 0"
            @choiceContent="choice"
            @closeFeedback="closeFeedback"
            @refresh="refreshDemandTable"
            ref="demandDetailPanel"
          ></side-panel>
          <div v-else>
            <div>
              <el-empty description="暂无需求"></el-empty>
            </div>
          </div>
        </div>
      </pane>
    </splitpanes>

    <!-- 新建需求弹窗 -->
    <el-dialog title="新建需求" :visible.sync="dialogAddDemand" width="30%">
      <div>
        <div>
          <el-form
            ref="formDemand"
            :model="formDemand"
            :rules="rules"
            label-width="110px"
          >
            <el-form-item label="项目负责人" prop="ChargeUserName">
              <el-input v-model="formDemand.ChargeUserName" disabled></el-input>
            </el-form-item>
            <el-form-item label="需求描述" prop="DemandDescription">
              <quill-editor
                class="editor"
                v-model="formDemand.DemandDescription"
                ref="myQuillEditor"
                :options="editorOption"
                :style="{
                  height: '200px',
                  background: '#fff',
                  borderRadius: '4px',
                  border: '1px solid #ededed'
                }"
              ></quill-editor>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogAddDemand = false">取 消</el-button>
        <el-button
          type="primary"
          :loading="addLoading"
          @click="ConfirmAddDemand"
          >确定新建</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import eventBus from "@/pages/EventBus";
import { mapState, mapGetters, mapMutations } from "vuex";
import { Splitpanes, Pane } from "splitpanes"; // 左右栏拖拽缩放

import elTableScrollToRow from "@/utils/elTableScrollToRow.js";

import ProjectInfoTabs from "@/pages/views/project/components/ProjectInfoTabs.vue"; // 详情面板
import SidePanel from "@/pages/views/project/components/SidePanel.vue"; // 需求面板
// import TaskList from "@/pages/views/project/components/TaskList.vue"; // 任务列表

import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";

import {
  GetUserByDepartList,
  GetProjectManagementBaseDetails,
  GetCustomerDemandManagementPageList,
  AddDemandManagement,
  GetAllReceiveProjectByProjectTotal,
  CloseDemandManagement,
  ReceiveDemandManagement
} from "@/api/index.js";

export default {
  computed: {
    ...mapState(["msgComment"]),
    ...mapGetters(["user"])
  },
  components: {
    ProjectInfoTabs,
    SidePanel,
    Splitpanes,
    Pane,
    quillEditor
  },
  data() {
    return {
      tableHeight: 0,

      loading: true,
      tableLoading: true,
      SidePanelData: [],

      baseDetailData: {},

      // 需求列表
      pageCurrent: 1,
      pageLimit: 10,
      tableTotalCount: 0,
      // 状态 1：待办  2：待分解   3：关闭  4：处理中   5：已完成
      tableData: [], // 需求列表数据
      // 来源于上面的tableData- 关联右侧面板数据
      projectTabsValue: "", // 项目信息中的第一个当前页 值
      projectTabs: [], // 项目信息中tabs 的新增续约编号

      params: {
        orderby: "DemandStatus asc ,Created desc"
      },
      dialogAddDemand: false, // 新建需求弹窗
      addLoading: false,

      formDemand: {
        ChargeUserName: "", // 项目负责人（项目经理）
        receiveUserGUID: "", // 项目负责人GUID（项目经理）
        DemandDescription: ""
        // AutoCreateTask: 0
      },
      rules: {
        receiveName: [
          {
            required: true,
            message: "请选择或输入负责人姓名",
            trigger: "change"
          }
        ],
        DemandDescription: [
          { required: true, message: "请选择需求描述", trigger: "blur" }
        ]
      },
      goToRow: {},

      tabsProjectId: "", // tabs切换时需要 的项目id
      addDemandFlag: false,

      showTableList: true, // true 时显示需求列表 false 时显示任务列表

      demandId: 0, // 需求Id
      demandNo: "", // 需求编号
      taskNo: "", // 任务编号
      parentNo: "", // 如果有这个值，说明他是子任务
      taskId: "", // 任务主键id

      currentTaskId: null,
      currentTaskParentId: null,
      currentTaskDemandId: null,
      currentTaskDemandNo: "",

      title: "",

      reenterFlag: false, // 重新进入任务列表
      newDemandNo: "",

      showChoice: true,
      projectManagerList: [], // 选择任务负责人列表数据
      feedback: false, // 把值传到任务列表中。可决定是否显示反馈按钮

      projectNo: "",

      editorOption: {
        modules: {
          toolbar: {
            container: [
              // [{ size: ["small", false, "large", "huge"] }], // 字体大小工具栏
              ["bold", "italic", "underline", "strike"], // // 加粗 斜体 下划线 删除线
              [{ color: [] }, { background: [] }] // 字体颜色、字体背景颜色
            ]
            // handlers: {
            // image: function () {
            // 劫持原来的图片点击按钮事件
            // Hijack the original picture click button event
            // QuillWatch.emit(this.quill.id);
            // }
            // }
          },
          clipboard: {
            matchers: [[Node.ELEMENT_NODE, this.handleCustomMatcher]]
          }
        },
        // 富文本编辑器配置，顶部的工具栏
        theme: "bubble", // 主题snow有工具栏 bubble 无工具栏
        placeholder: "在这里输入评论内容..."
      }
    };
  },

  activated() {},
  watch: {},
  created() {
    if (this.$route.query.projectId && this.$route.query.projectTotalId) {
      this.searchQuery = this.$route.query.projectTotalId.replace(
        /^[a-zA-Z]+/,
        ""
      );
    }
    this.tabsProjectId = this.$route.query.projectId;
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$route.query.projectTotalId) {
        // 当有tabs 时的高度
        this.tableHeight = window.innerHeight - 434;
      } else {
        // 没有tabs 时的高度
        this.tableHeight = window.innerHeight - 420;
      }
    });

    sessionStorage.setItem("searchFlag", true);

    this.UserList();
    this.getDetails(); // 获取合同详情
    // this.fnGetReceiveProjectUserNew(); // 根据部门返回用户
    this.fnGetAllReceiveProjectByProjectTotal(); // 获取所有新增/续约项目

    if (this.$route.query.taskNo) {
      this.showTableList = false;
      this.demandNo = this.$route.query.demandNo;
      this.demandId = Number(this.$route.query.id);
    } else {
      this.getTableListData(); // 获取需求列表分页
    }

    eventBus.$on("reenter", (msg) => {
      this.reenterFlag = msg;
      // console.log("this.reenterFlag", this.reenterFlag);
    });
  },
  methods: {
    // 需求描述禁止插入截图
    handleCustomMatcher(node, Delta) {
      // console.log(node, Delta);
      let ops = [];
      Delta.ops.forEach((op) => {
        if (op.insert && typeof op.insert === "string") {
          ops.push({
            insert: op.insert,
            attributes: op.attributes // 文字样式（包括背景色和文字颜色等)
          });
        } else {
          this.$message.warning("描述內容不支持图片！");
        }
      });
      Delta.ops = ops;
      return Delta;
    },
    // 获取所有新增/续约项目
    fnGetAllReceiveProjectByProjectTotal() {
      GetAllReceiveProjectByProjectTotal({
        ProjectTotalId: this.$route.query.projectTotalId
      })
        .then((res) => {
          // this.projectTabsValue = res.data[0].projectId;
          this.projectTabsValue = this.$route.query.projectId;

          this.projectTabs = res.data.map((item) => {
            return {
              ...item,
              projectId: item.projectId.toString()
            };
          });
        })
        .catch((err) => {
          console.log("catch: ", err);
        })
        .finally((fin) => {
          // console.log("fin: ", fin);
        });
    },

    getTableAndDetail(projectId) {
      this.tabsProjectId = projectId;
      this.getDetails();
      this.getTableListData();
      this.showTableList = true;
    },

    // 把每一行的索引放进row
    tableRowClassName({ row, rowIndex }) {
      if (this.newDemandNo) {
        row.index = rowIndex;
        if (row.demandNo === this.newDemandNo) {
          this.goToRow = row;
        }
        return "demand-no-" + row.demandNo;
      } else {
        row.index = rowIndex;
        if (row.demandNo === this.$route.query.demandNo) this.goToRow = row;
        return "demand-no-" + row.demandNo;
      }
    },

    ...mapMutations("msgComment", ["SET_MERGE", "SET_FILE", "RESET"]),
    // 点击行显示需求面板
    clickRow(row, column, event) {
      // console.log(row)
      if (row.index !== this.index) {
        // 点击不同行进行操作
        this.SidePanelData = row;
        this.newDemandNo = row.demandNo;
        this.feedback = false; // 隐藏任务面板中的 按钮
        this.RESET(); // 清空选择的任务评论和任务附件数据
      }
      this.index = row.index;
      // console.log(row);
    },

    // 点击打开任务面板
    openTaskList(row) {
      this.demandId = row.id;
      this.demandNo = row.demandNo;
      this.newDemandNo = row.demandNo;
      this.showTableList = false;
      if (row.index !== this.index) {
        this.RESET(); // 清空选择的任务评论和任务附件数据
      }
      this.index = row.index;
    },

    // 状态 1：待办  2：待分解   3：关闭  4：处理中   5：已完成
    handleState(data) {
      switch (data) {
        case 4:
          return "已关闭";
        case 0:
          return "待办";
        case 1:
          return "待分解";
        case 2:
          return "处理中";
        case 3:
          return "已完成";
        default:
          return "已反馈";
      }
    },

    // 获取合同详情
    getDetails(projectId = this.tabsProjectId) {
      this.loading = true;
      let params = {
        ProjectId: projectId
      };
      GetProjectManagementBaseDetails(params)
        .then((res) => {
          this.baseDetailData = res.data;
          this.baseDetailData.projectId = projectId;

          // 新建需求中的项目负责人设置
          this.formDemand.ChargeUserName = this.baseDetailData.receiveName;
          this.formDemand.ChargeUserGUID = this.baseDetailData.receiveUserGUID;

          // 遍历全部合同，如果合同过期时间 ServiceEndDate 最远的合同结束时间    跟当天比较是否过期， 判断是否显示新建需求按钮
          // 暂时不处理
        })
        .catch((err) => {
          console.warn(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // 获取需求分页
    getTableListData(projectId = this.tabsProjectId) {
      this.tableLoading = true;
      let params = {
        page: 1,
        pageSize: 999,
        ProjectId: projectId,
        ProjectNo: "", // 新增/续约项目编号
        CommunicationTimeStart: "",
        CommunicationTimeEnd: "",
        CreatedStart: "",
        orderby: this.params.orderby
      };
      GetCustomerDemandManagementPageList(params)
        .then((res) => {
          this.tableData = res.data.data;
          this.tableTotalCount = res.data.totalCount;
          this.tableLoading = false;

          // this.SidePanelData = this.tableData[0]; // 右侧面板数据

          if (this.$route.query.projectTotalId && !this.reenterFlag) {
            // 项目管理进入项目详情页
            this.$nextTick(() => {
              this.SidePanelData = this.tableData[0]; // 右侧面板数据
              this.$refs.planTable.setCurrentRow(this.tableData[0]);
            });
          } else {
            this.$nextTick(() => {
              // 延迟1.2秒滚动定位需求
              setTimeout(() => {
                elTableScrollToRow(this.$refs.planTable, this.goToRow);
                this.$refs.planTable.setCurrentRow(this.goToRow);
                this.clickRow(this.goToRow);
              }, 1200);
            });
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },

    // 排序 {column,prop,order} 列数据|排序字段|排序方式
    sortChange(column) {
      if (column) {
        if (column.order === "ascending") {
          this.params.orderby = "Created asc";
        } else if (column.order === "descending") {
          this.params.orderby = "Created desc";
        } else {
          this.params.orderby = "DemandStatus asc ,Created desc";
        }
      }
      this.getTableListData();
    },
    openDialogAddDemand() {
      this.dialogAddDemand = true;
      this.$nextTick(() => {
        this.$refs.formDemand.resetFields();
      });
    },
    // 确定新建需求
    ConfirmAddDemand() {
      this.$refs.formDemand.validate((valid) => {
        if (valid) {
          this.addLoading = true;

          this.dialogAddDemand = false;
          let data = {
            ProjectId: this.baseDetailData.projectId,
            ProjectNo: this.baseDetailData.projectNo,
            DemandDescription: this.formDemand.DemandDescription,
            ChargeUserGUID: this.formDemand.ChargeUserGUID
            // AutoCreateTask: this.formDemand.AutoCreateTask
          };
          let formData = new FormData();
          formData.append("ProjectId", data.ProjectId);
          formData.append("ProjectNo", data.ProjectNo);
          formData.append("DemandDescription", data.DemandDescription);
          formData.append("ChargeUserGUID", data.ChargeUserGUID);
          // formData.append("AutoCreateTask", data.AutoCreateTask);

          AddDemandManagement(formData)
            .then((res) => {
              // console.log(res);
              this.getTableListData();
            })
            .catch((err) => {
              console.warn(err);
            })
            .finally((res) => {
              this.addLoading = false;
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    TabsSwitching(tabsProjectNo) {
      console.log(tabsProjectNo);
    },

    // 显示需求面板
    showDemand(val) {
      this.projectNo = val;
      this.getTableListData(); // 获取需求列表分页
      this.showTableList = val;
    },

    // 显示新增任务面板
    showAddTaskPanel(val) {
      this.title = "新增任务";
      this.currentTaskId = 0;
    },

    // 点击任务列表行-刷新任务详情
    UpdateTaskDetails(task) {
      this.currentTaskId = task.id;
      this.currentTaskParentId = task.parentId;
    },

    // 刷新需求列表
    refreshDemandTable() {
      this.getTableListData(); // 获取需求列表分页
    },

    // 刷新任务列表
    refreshTable() {
      eventBus.$emit("RefreshTableList"); // 传数据到TaskList.vue组件中  刷新任务列表
      this.reenterFlag = true; //  把值传入TaskList组件中 重新进入后，都默认显示第一行
    },
    // 切换右侧面板
    showAddPanel(val) {
      // console.log(val);
      this.title = "新增子任务";
    },

    loadTable() {
      eventBus.$emit("RefreshTableList"); // 传数据到TaskList.vue组件中  刷新任务列表
    },

    // 关闭该条需求
    closeDemand(id) {
      let params = {
        Id: id
      };
      this.$confirm("确认关闭该条需求？", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        CloseDemandManagement(params)
          .then((res) => {
            this.$message({
              message: "该需求已关闭",
              type: "success"
            });
            this.SidePanelData.demandStatus = 4;
          })
          .catch((err) => {
            console.warn(err);
          });
      });
    },

    // 关闭该条需求
    receiveDemand(id) {
      let params = {
        Id: id
      };
      this.$confirm("确认接收该条需求？", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        ReceiveDemandManagement(params)
          .then((res) => {
            this.$message({
              message: "该需求已接收",
              type: "success"
            });
            this.SidePanelData.demandStatus = 1;
          })
          .catch((err) => {
            console.warn(err);
          });
      });
    },

    // 根据部门返回用户
    UserList() {
      let params = {
        departId: "2792,451,281,2803,710,450,2794" // 直接写死 全部部门id
      };
      GetUserByDepartList(params)
        .then((res) => {
          for (var i = 0; i < res.data.length; i++) {
            this.projectManagerList.push({
              userName: res.data[i].userName,
              chargeUserGUID: res.data[i].userGUID
            });
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },

    choice(val) {
      // 跳转当前需求的任务列表
      this.demandId = this.SidePanelData.id;
      this.demandNo = this.SidePanelData.demandNo;
      this.newDemandNo = this.SidePanelData.demandNo;
      this.showTableList = false;

      this.feedback = true; // 显示任务面板中的 按钮
    },

    closeFeedback(val) {
      this.feedback = false; // 隐藏任务面板中的 按钮
    }
  }
};
</script>

<style lang="scss" scoped>
.icon-user {
  font-size: 14px;
  display: inline-block;
  margin-right: 2px;
}
::v-deep .my-content {
  overflow: hidden;
  word-break: break-all;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  display: -webkit-box;
}

.table-list {
  background: linear-gradient(180deg, rgba(230, 240, 255, 0.6) 80%, #fff);
  // margin-top: 20px;
  padding: 20px;
  min-height: 260px;
  .demand-head {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}

.icon-base-list {
  font-weight: 400;
  margin-right: 10px;
  color: var(--brand);
}

::v-deep .el-scrollbar__wrap {
  overflow-x: hidden;
}

.scrollbar {
  height: 100%;
}

// splitPanes

/deep/.splitpanes {
  background-color: #fff;

  &__pane {
    justify-content: center;
    align-items: center;
    display: flex;
  }

  &__splitter {
    background-color: #f4f6f8;
    position: relative;
    min-width: 5px;
    cursor: col-resize;

    &:before {
      content: "";
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      transition: 0.4s;
    }
    &:hover {
      &::before {
        opacity: 1;
      }
    }
  }

  &--vertical > &__splitter:before {
    left: -30px;
    right: -30px;
    height: 100%;
  }

  &__splitter:hover:before {
    background-color: var(--brand);
  }
}
.main-box {
  padding-top: 0;
}

// splitPanes End
.el-pagination {
  padding-bottom: 30px;
}
.breadcrumb {
  padding: 15px 20px 15px;
}
.el-select-dropdown__item:last-child {
  margin-bottom: 20px;
}
::v-deep .splitpanes__pane {
  overflow: inherit;
}
.task-list-wrap {
  padding: 20px;
  margin-top: 20px;
  background: linear-gradient(180deg, #f1f9ff 60%, #fff);
}

::v-deep .el-tag--feedback {
  background-color: #f5e9ff;
  border-color: #e1cdf1;
  color: #9552c8;
}
</style>
